import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Loader = styled.div`
  position: relative;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background: linear-gradient(#070519, #4a3aff, #4361ee);
  animation: animate 2s linear infinite;

  &:after {
    content: '';
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    background: #070519;
    border: solid #070519 10px;
    border-radius: 50%;
  }

  @keyframes animate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }

  span {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,127,255,1) 50%, rgba(0,127,255,1) 100%, rgba(0,127,255,1) 100%);

    &:nth-child(1) {
      filter: blur(4px);
    }

    &:nth-child(2) {
      filter: blur(8px);
    }

    &:nth-child(3) {
      filter: blur(16px);
    }

    &:nth-child(3) {
      filter: blur(32px);
    }
  }
`;